import { useRef, useState } from 'react'
import { Divider, Card } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { SubmitModal } from '../SubmitModal/SubmitModal'

import { PercentButton, Loader, ErrorView } from '@percent/admin-dashboard/common/components'
import { WebsiteCopyLink } from '@percent/admin-dashboard/common/components/websiteCopyLink/WebsiteCopyLink'
import { OrganisationDetailsProps } from './OrganisationDetails.types'
import styles from './OrganisationDetails.module.scss'
import { useActivityTags } from '@percent/admin-dashboard/common/hooks/useActivityTags/useActivityTags'
import { useActivityAccess } from '@percent/admin-dashboard/common/hooks'

export function OrganisationDetails({
  organisation,
  subTagsForm,
  errorMessage,
  isLoading,
  isFlagged,
  isNoneOfTheAbove
}: OrganisationDetailsProps) {
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)
  const [isSubmitModalOpened, setIsSubmitModalOpened] = useState(false)

  const { activityTags } = useActivityTags({ filterByEducation: false })
  const { canCreateEvent } = useActivityAccess()

  if (errorMessage) {
    return <ErrorView errorMessage={errorMessage} />
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <Card className={styles.wrapper} ref={ref}>
        <Divider flexItem className={styles.divider} />
        <div className={styles.contentWrapper}>
          <div className={styles.organisationInfoWrapper}>
            <span className={styles.text}>{organisation?.displayName ?? organisation?.name}</span>
            <WebsiteCopyLink orgWebsite={organisation?.website} />
          </div>
          {canCreateEvent && (
            <div className={styles.buttonWrapper}>
              <PercentButton
                testId="submit-tags-button"
                title={t('button.submitTags')}
                onClick={() => setIsSubmitModalOpened(true)}
                disabled={isFlagged || isNoneOfTheAbove ? false : !subTagsForm?.some(subTag => subTag.meetsCriteria)}
              />
            </div>
          )}
        </div>
      </Card>

      {isSubmitModalOpened && (
        <SubmitModal
          isOpened={isSubmitModalOpened}
          setIsOpened={setIsSubmitModalOpened}
          organisation={organisation}
          subTagsForm={subTagsForm}
          isFlagged={isFlagged}
          tagsData={activityTags}
          isNoneOfTheAbove={isNoneOfTheAbove}
        />
      )}
    </>
  )
}
